<template>
  <d2-container>
    <template slot="header">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openPackage()">新增无限积分包</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="ID" width="120"></el-table-column>
      <el-table-column prop="name" label="名称" min-width="160"></el-table-column>
      <el-table-column prop="price" label="金额" width="110" align="right"></el-table-column>
      <el-table-column prop="creditCount" label="兼容成长币" width="120" align="right"></el-table-column>
      <el-table-column prop="aiPointAmount" label="无限积分" width="120" align="right"></el-table-column>
      <el-table-column prop="firstAiPointAmount" label="首充无限积分" width="140" align="right"></el-table-column>
      <el-table-column prop="aiPointValidityDays" label="有效天数" width="110" align="center"></el-table-column>
      <el-table-column prop="aiPointExpireAt" label="固定过期时间" width="170"></el-table-column>
      <el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
      <el-table-column label="首充" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.firstCharge === 1 ? '开启' : '关闭' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openPackage(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog :title="form.id ? '编辑无限积分包' : '新增无限积分包'" :visible.sync="dialog" width="720px">
      <el-form :model="form" label-width="140px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="名称" required>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额" required>
              <el-input-number v-model="form.price" :min="0" :precision="2" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="无限积分" required>
              <el-input-number v-model="form.aiPointAmount" :min="0" :precision="4" :step="10" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="兼容成长币">
              <el-input-number v-model="form.creditCount" :min="0" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="首充优惠">
              <el-switch v-model="firstChargeEnabled"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首充无限积分">
              <el-input-number v-model="form.firstAiPointAmount" :min="0" :precision="4" :step="10" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="有效天数">
              <el-input-number v-model="form.aiPointValidityDays" :min="0" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="固定过期时间">
              <el-date-picker v-model="form.aiPointExpireAt" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="图标">
          <upload-image
            v-model="form.icon"
            :max="1"
            :show-tips="false"
            :width="120"
          ></upload-image>
        </el-form-item>
        <el-form-item label="首充图标">
          <upload-image
            v-model="form.firstIcon"
            :max="1"
            :show-tips="false"
            :width="120"
          ></upload-image>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :step="1"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getGrowthCoinList,
  addGrowthCoin,
  getGrowthCoinDetail,
  updateGrowthCoinDetail,
  delGrowthCoin
} from '@/api/demo/GrowthCoin/index'
import UploadImage from '@/components/uploadImage/index.vue'

export default {
  name: 'aiPointPackageManager',
  components: { UploadImage },
  data () {
    return {
      query: { currentPage: 1, pageSize: 20 },
      records: [],
      total: 0,
      loading: false,
      dialog: false,
      form: this.defaultForm()
    }
  },
  computed: {
    firstChargeEnabled: {
      get () {
        return this.form.firstCharge === 1
      },
      set (value) {
        this.form.firstCharge = value ? 1 : 0
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    defaultForm () {
      return {
        name: '',
        icon: '',
        price: 0,
        sort: 100,
        creditCount: 0,
        firstCharge: 0,
        firstCreditCount: 0,
        firstIcon: '',
        aiPointAmount: 0,
        firstAiPointAmount: 0,
        aiPointValidityDays: 30,
        aiPointExpireAt: ''
      }
    },
    load () {
      this.loading = true
      getGrowthCoinList(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    openPackage (row) {
      if (!row) {
        this.form = this.defaultForm()
        this.dialog = true
        return
      }
      getGrowthCoinDetail(row.id).then(res => {
        this.form = Object.assign(this.defaultForm(), res || {}, { id: row.id })
        this.dialog = true
      })
    },
    save () {
      const payload = Object.assign({}, this.form)
      const request = payload.id ? updateGrowthCoinDetail(payload.id, payload) : addGrowthCoin(payload)
      request.then(() => {
        this.$message.success('保存成功')
        this.dialog = false
        this.load()
      })
    },
    remove (row) {
      this.$confirm('确认删除该无限积分包？', '提示').then(() => {
        delGrowthCoin(row.id).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      })
    }
  }
}
</script>
